import { type JobSummaries, type JobSummary } from '../useGetJobSummaries'

export const summariesUpdater = (newJob: JobSummary) => {
  return (old: JobSummaries | undefined): JobSummaries => ({
    results: [...(old?.results ?? []), newJob],
    isUsingJGit: old?.isUsingJGit ?? false
  })
}
